/**
 * Entry del bundle IIFE del SDK.
 *
 * Expone `window.Finva` (global) para que los comercios lo carguen con un
 * `<script src="...">`. R5 (build) empaqueta este archivo con esbuild
 * (`format: 'iife'`, sin dependencias runtime, sin React).
 */
import { Finva } from './core/finva';

export { Finva } from './core/finva';
export type { FinvaOptions, BrickSettings, BrickController } from './core/api';
export type {
  FinvaMode,
  FinvaTheme,
  InitPayload,
  UpdatePayload,
  SubmitData,
  FinvaError,
  HostToIframe,
  IframeToHost,
} from './transport/protocol';

// Asignación global (entry del bundle IIFE).
(globalThis as unknown as { Finva?: typeof Finva }).Finva = Finva;